import { Injectable } from '@angular/core';
import { B2cConfig } from '../models/b2cConfig';
import moment from 'moment-timezone';
import { DatastoreService } from "./datastore.service";
import { inject } from '@angular/core';
import { Buffer } from 'buffer';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import { ExtendedJwtPayload } from '../models/ExtendedJwtPayload.model';

@Injectable({
  providedIn: 'root'
})
export class B2cService {

  clientId: string;
  host: string;
  policy: string;
  nonce:string;
  currentState: URLSearchParams;
  token: string;
  decodedToken: ExtendedJwtPayload;
  verified: boolean;
  company: any;
  service: any;

  dataStore: DatastoreService = inject(DatastoreService);
  constructor() { }

  set(data: B2cConfig) {
    this.clientId = data.clientId;
    this.host = data.host;
    this.policy = data.policy;
    if (!this.nonce) {
      this.generateNonce();
    }
  }

  private generateNonce() {
    const time = moment().tz('Europe/London').format('YYYY-MM-DDTHH:mm:ss');
    console.log(this.dataStore.config);
    if (this.dataStore.config.hasOwnProperty('journey_config')) {
      if (this.dataStore.config.journey_config.hasOwnProperty('ceremonies')) {
        const appName = 'ceremonies';
        this.nonce = `${appName}-${time}`;
      }
      else {
        this.nonce = 'defaultNonce';
      }
    }
    else {
      this.nonce = 'defaultNonce';
    }
    console.log(`Nonce set to ${this.nonce}`);
    return this;
  }

  private generateState(companyId: number, serviceId: number, basketId: string, serviceItemId: string, authToken: string, fees: any) {
    const params = new URLSearchParams();
    params.set('company_id', companyId.toString());
    params.set('service_id', serviceId.toString());
    params.set('basket_id', basketId);
    params.set('service_item_id', serviceItemId);
    params.set('auth_token', authToken);
    params.set('fees', JSON.stringify(fees));
    this.currentState = params;

    return this;
  }

  sendToAuth() {
    // this.generateState(companyId, serviceId, basketId, serviceItemId, authToken, fees);
    // const state = Buffer.from(this.currentState.toString()).toString('base64');
    // console.log('state', state);
    const _url = `${this.host}/oauth2/v2.0/authorize?client_id=${this.clientId}&p=${this.policy}&nonce=${this.nonce}&redirect_uri=https://westminster.myceremony.staging.bookinglab.co.uk/&scope=openid&response_type=id_token&promt=login&response_mode=query`;
    console.log(`redirecting to ${_url}`);
    window.location.href = `${_url}`;
  }

  getExpiry() : moment.Moment {
    return moment.unix(this.decodedToken.exp).utc().tz('Europe/London');
  }
  getNotBefore() : moment.Moment {
    return moment.unix(this.decodedToken.nbf).utc().tz('Europe/London');
  }
  getIssuedAt() : moment.Moment {
    return moment.unix(this.decodedToken.iat).utc().tz('Europe/London');
  }
  getAuthTime () {
    return moment.unix(this.decodedToken.auth_time).utc().tz('Europe/London');
  }

  isTokenExpired() : boolean {
    console.log(this.decodedToken);
    const exp = moment.unix(this.decodedToken.exp).utc().tz('Europe/London');
    return moment().utc().tz('Europe/London').isSameOrAfter(exp);
  }

  removeDecodedToken() : B2cService {
    delete this.decodedToken;
    return this;
  }

  // verifyToken() {
  //   if (this.decodedToken.nonce) {
  //     this.verified = (this.nonce === this.decodedToken.nonce) ? true : false;
  //   }
  //   return this;
  // }

  decodeToken() {
    const decoded = jwtDecode(this.token);
    const _decodedToken:JwtPayload = decoded;
    const finalPayload:ExtendedJwtPayload = JSON.parse(JSON.stringify(_decodedToken));
    this.decodedToken = finalPayload;
    return this;
  }


} 